export default {
  aproved: 'APPROVED',
  rejected: 'REJECTED',
  pending: 'PENDING',
  regular: 'REGULAR',
  review: 'IN_REVIEW',
  draft: 'DRAFT'
};
